import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Container = styled.div`
  width: 100%;
`;

export const Columns = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$columns}, minmax(0, 1fr));
  gap: ${space[6]};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Header = styled.div`
  margin-bottom: ${space[4]};
`;

export const StaticHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: ${layout.inputPadding};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadiusMd};
  background: ${colors.white};
`;

export const HeaderLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xxs};
  color: ${colors.fontSecondary};
  line-height: 1.2;
`;

export const HeaderName = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  line-height: 1.3;
`;

export const TriggerValue = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: normal;
  text-align: left;
`;

export const DateGroup = styled.div`
  display: grid;
  grid-template-columns: ${space[10]} 1fr;
  gap: ${space[4]};
  padding-top: ${space[4]};

  &[data-single='true'] {
    display: block;
  }
`;

export const DateLabel = styled.h4`
  margin: 0;
  padding-top: ${space[3]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  white-space: nowrap;

  [data-single='true'] > & {
    padding-top: 0;
    margin-bottom: ${space[2]};
  }
`;

export const Activities = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const ActivityRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[4]};
  padding: ${space[3]} 0;
  border-bottom: 1px solid ${colors.borderGreyLighter};
`;

export const ActivityText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ActivityTitle = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};
  line-height: 1.3;
`;

export const ActivityLocation = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
  line-height: 1.3;
`;
